<app-menu></app-menu>
<router-outlet></router-outlet>